import React from 'react';
import ContinueButton from '../ContinueButton'
import NewIncomeForm from './NewIncomeForm';
import IncomeCards from '../IncomeUtils';
import { url } from '../../../../config';
import GoBackButton from '../../Common/GoBackButton';
import s from '../../Common/GoBackButton.scss';
import { tooltips } from '../../../../tooltips';
import Tooltip from 'rc-tooltip';
import Help from '../../../../assets/images/icons/help-circle.svg';
import sc from '../ChatsForm.scss';

export default class IncomesForm extends React.Component {
    state = {
        thereismore: false,
        incomesLength: this.props.incomes.length,
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let thereismore = prevState.thereismore
        if (nextProps.incomes.length > prevState.incomesLength) thereismore = null;
        return {
            thereismore,
            incomesLength: nextProps.incomes.length,
        };
    }

    changeTherismore = bool => () =>  {
        this.setState({
            thereismore: bool,
        });
    }

    render() {
        const {
            incomes,
            values,
            submitIncomeForm,
            errors,
            deleteIncome,
            incomeSubmit,
            match,
            editIncome,
            userBorrower,
            apptype,
            is_staff
        } = this.props;
        const { thereismore } = this.state;
        return (
            <div>
                <div  className={sc.formContainer}>
                    <div className={s.goBack}><GoBackButton children={'Volver'} link={url('personales', apptype)}/></div>
                    <h3 className="chat-title">
                        Tus ingresos
                        <Tooltip destroyTooltipOnHide placement="bottom" trigger={['click', 'hover']} overlayStyle={{ maxWidth: '300px'}} overlay={tooltips.incomes.map(({ description }) => [description])}>
                            <img className={sc.helpImg} src={Help} alt={"icono de ayuda"}></img>
                        </Tooltip>
                    </h3>
                    <IncomeCards incomes={incomes} is_staff={is_staff} deleteIncome={deleteIncome} url={match.url} path={match.path} editIncome={editIncome} userBorrower={userBorrower} />
                    {(!!incomes.length && !thereismore) && <p style={{ textAlign: 'center', marginBottom: '40px'}}><a className={sc.addIncome} onClick={this.changeTherismore(true)}>Agregar otros ingresos</a></p>}
                    {(thereismore || !incomes.length) &&
                        <NewIncomeForm
                            onSubmit={incomeSubmit}
                            errors={errors}
                            values={values}
                            incomesLength={incomes.length}
                            cancelForm={this.changeTherismore(false)}
                            showCancel={!!incomes.length}
                            placeholder="35.000"
                            apptype={apptype}
                        />
                    }
                        {!thereismore && !!incomes.length &&
                            <ContinueButton autoFocus={false} sticky={true} type="button" onClick={submitIncomeForm}/>
                        }
                </div>
            </div>
        );
    }
}
